import React from "react";
import { provided_by_options } from "../../../../../constants";

export default function SimProvidedBy(props) {
    const { name, label, onChange, value } = props;

    return (
        <div class="input-wrapper">
            <label htmlFor={name}>{label}</label>
            <select name={name} id={name} onChange={onChange}>
                <option value={""} selected={value == ""}>
                    None
                </option>
                {provided_by_options.map((item) => (
                    <option value={item.value} selected={value == item.value}>
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
